import { styled } from '@mui/material';

import { I18nResources, useI18n } from '@app-velocity/i18n';

import { Typography } from '../../../Typography';

export type TitleProps = {
  title: I18nResources;
};

const StyledTitle = styled(Typography)({
  fontWeight: 600,
  whiteSpace: 'wrap',
  fontSize: 18,
});

export const Title = ({ title }: TitleProps) => {
  const { t } = useI18n();

  return (
    <StyledTitle variant="header" component="h2">
      {t(title)}
    </StyledTitle>
  );
};
